import PropTypes from "prop-types";
import classNames from "classnames";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { memo } from "react";

const FilterPredicates = ({
	label,
	predicates = [],
	activeIfEqualTo,
	onSelect,
	customiseLabelFunction,
}) => {
	return (
		<div className="filter-predicates">
			{label ? (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					className="filter-predicates__label"
				>
					{label}
				</Typography>
			) : null}
			<div className="filter-predicates__items">
				{predicates.map(predicate => {
					const filterClassname = classNames({
						"filter-predicates__item": true,
						"click-away-ignore": true, // do not close the sidepanel when clicking on this element
						"filter-predicates__item--active": predicate === activeIfEqualTo,
					});

					return (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.REGULAR}
							key={predicate}
							className={filterClassname}
							onClick={() => {
								onSelect(predicate);
							}}
						>
							{customiseLabelFunction ? customiseLabelFunction(predicate) : predicate}
						</Typography>
					);
				})}
			</div>
		</div>
	);
};

FilterPredicates.propTypes = {
	label: PropTypes.node,
	predicates: PropTypes.array,
	activeIfEqualTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onSelect: PropTypes.func,
	customiseLabelFunction: PropTypes.func,
};

export default memo(FilterPredicates);
